var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"mr-3 font-weight-bold",class:_vm.bgColor,attrs:{"left":_vm.left,"size":_vm.size}},[(_vm.notAssigned)?_c('v-icon',[_vm._v("mdi-account-remove-outline")]):_c('span',[_vm._v(_vm._s(_vm.salesPersonInitials))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }